import React, { useState, useEffect } from 'react';
import './PaginatedTable.css';

const PaginatedTable = ({ data }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const totalPages = (data && data.length > 0) ? Math.ceil(data.length / itemsPerPage) : 0;

    useEffect(() => {
        setCurrentPage(0);
    }, [data]);

    const handleClick = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value));
        setCurrentPage(0);
    };

    return (
        <div>
            <table id="responses" className="table-container">
                <thead>
                    <tr className="columnHeaders">
                        <th style={{ textAlign: 'center'}}>Curso Académico</th>
                        <th style={{ textAlign: 'center' }}>Comentarios</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data.length > 0 ? data.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage).map((row, index) => (
                        <tr key={index}>
                            <td style={{textAlign: 'center'}}>{row.cur_academ + '/' + (parseInt(row.cur_academ) + 1 ) }</td>
                            <td style={{ textAlign: 'left' }}>{row.respuesta}</td>
                        </tr>
                    )) :
                    <tr>
                        <td style={{ textAlign: 'center' }} colSpan="2">NO HAY COMENTARIOS</td>
                    </tr>}
                </tbody>
            </table>

            <div className="pagination-container">
                <select value={itemsPerPage} onChange={handleItemsPerPageChange} className='items-per-page-select'>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                </select>
                <div className='pagination-text-and-buttons'>
                    <button onClick={() => handleClick(currentPage - 1)} disabled={currentPage === 0}>Anterior</button>
                    <span className="pagination-text">Página {totalPages > 0 ? currentPage + 1 : 0} de {totalPages}</span>
                    <button onClick={() => handleClick(currentPage + 1)} disabled={currentPage === totalPages - 1 || totalPages === 0}>Siguiente</button>
                </div>
            </div>
        </div>
    );
};

export { PaginatedTable };